var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.handler.mode === 'list')?_c('div',[_c('list-component',{attrs:{"handler":_vm.handler.list}}),_c('list-component',{attrs:{"handler":_vm.listFooter}})],1):_c('table-component',{attrs:{"handler":_vm.handler.table}})}
var staticRenderFns = []

export { render, staticRenderFns }